export default "__VITE_ASSET__4B0JB4x9__"